export default __webpack_public_path__ + "static/media/bruinplate.a775e2c4.jpeg";